<template>
  <div class="auth-container">
    <div class="auth-header">
      <slot />
    </div>
  </div>
</template>
  